import React from 'react'
import styles from './button.module.css'
import { Link } from 'gatsby'

export default ({ children, to }) => (
  <Link className={styles.button} to={to} >{children}</Link>
)
